import { render } from "./Sherrysession.vue?vue&type=template&id=5465bc71&scoped=true"
import script from "./Sherrysession.vue?vue&type=script&lang=js"
export * from "./Sherrysession.vue?vue&type=script&lang=js"

import "./Sherrysession.vue?vue&type=style&index=0&id=5465bc71&scoped=true&lang=css"

import exportComponent from "/Users/ward/Projects/Chelsea/sherryV2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5465bc71"]])

export default __exports__